export default [
  {
    path: '/working-time',
    name: 'working-time',
    component: () => import('@/views/workingSchedule/index.vue'),
    meta: {
      pageTitle: 'breadcrumb.workingTime',
      // resource: 'manage-working-schedule',
      resource: 'manage-department',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.timeShift',
          active: true,
        },
      ],
    }
  }
];
